// functions injected to facilitate testing
export const CSS_VARS_POLYFILL = 'CSS_VARS_POLYFILL';
export const BUILD_CSS_VARIABLES = 'BUILD_CSS_VARIABLES';

// lifecycle hooks
export const SURVEYS_LIFECYCLE_SURVEY_LOADED = 'SURVEYS_LIFECYCLE_SURVEY_LOADED';

// development
